/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./dataSources.vue?vue&type=template&id=48f7fbeb"
import script from "./dataSources.vue?vue&type=script&lang=js"
export * from "./dataSources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports